let myAIF;
const allocInit=() => {
	fetch(`data.json?v=${document.body.dataset.json}`)
		.then( response => {
			if(response.status == 200) {
				return response.json();
			} else {
				throw "Respuesta incorrecta del servidor";
			}
		})
		.then( response => {
			myAIF=new AIF(response);
		})
		.catch( err => {
			console.log(err);
		});
};
document.addEventListener('DOMContentLoaded', allocInit, !1);
